export type FeaturePaymentMethodTranslationKeys =
  | 'PAYMENT_METHOD_CREDIT_CARD_OPTION_LABEL'
  | 'PAYMENT_METHOD_DIRECT_DEBIT__HIGHLIGHTED_TEXT'
  | 'PAYMENT_METHOD_DIRECT_DEBIT_OPTION_LABEL'
  | 'PAYMENT_METHOD_ERROR_REQUIRED'
  | 'PAYMENT_METHOD_FORM_SUBMIT_BUTTON'
  | 'PAYMENT_METHOD_LABEL'
  | 'PAYMENT_METHOD_MONTHLY_LABEL'
  | 'PAYMENT_METHOD_ONE_OFF_LABEL'
  | 'PAYMENT_METHOD_TOTAL_COST';
